import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { CONSTANTS } from 'src/app/constants';

@Component({
  selector: 'app-percentage-billed',
  templateUrl: './percentage-billed.component.html',
  styleUrls: ['./percentage-billed.component.css']
})
export class PercentageBilledComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  @Output() errorEmitter = new EventEmitter();

  loading: boolean = false;

  percentage = [
    {"percentage": 0},
    {"percentage": 0},
    {"percentage": 0},
    {"percentage": 0},
    {"percentage": 0},
    {"percentage": 0},
    {"percentage": 0},
  ];
  errorApi: boolean = false;
  message: string = "";

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.loading = true;
      let excelInfo: any[] = [];
      this.weekdaysReturn(item).subscribe((data: any) => {
        data.dataRow.map((el:any) => {
          if (el.saledatetime_weekday == 1) {
            this.percentage[0].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Domingo', 'Porcentagem': el.percentage_value + '%'});
          } else if (el.saledatetime_weekday == 2) {
            this.percentage[1].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Segunda', 'Porcentagem': el.percentage_value + '%'});
          } else if (el.saledatetime_weekday == 3) {
            this.percentage[2].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Terça', 'Porcentagem': el.percentage_value + '%'});
          } else if (el.saledatetime_weekday == 4) {
            this.percentage[3].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Quarta', 'Porcentagem': el.percentage_value + '%'});
          } else if (el.saledatetime_weekday == 5) {
            this.percentage[4].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Quinta', 'Porcentagem': el.percentage_value + '%'});
          } else if (el.saledatetime_weekday == 6) {
            this.percentage[5].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Sexta', 'Porcentagem': el.percentage_value + '%'});
          } else if (el.saledatetime_weekday == 7) {
            this.percentage[6].percentage = el.percentage_value;
            excelInfo.push({'Data Inicial': item.dataMin, 'Data Final': item.dataMax, 'Dia': 'Sábado', 'Porcentagem': el.percentage_value + '%'});
          }
        });
        excelInfo.unshift({});
        localStorage.setItem('percentage-billed-sellers', JSON.stringify(excelInfo));
        this.loading = false;
        this.errorApi = false;
      },
      (error) => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_PERCENTAGE_BILLED;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  weekdaysReturn(item: any) {
    return this.api.postWeekdaysSellerPanel(item.dataMin, item.dataMax, item.branch);
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataPercentageBilled = [];
    let objectPercentageBilled = localStorage.getItem('percentage-billed-sellers');

    objectPercentageBilled != null
      ? (dataPercentageBilled = JSON.parse(objectPercentageBilled))
      : (dataPercentageBilled = []);
    const worksheetPercentageBilled= XLSX.utils.json_to_sheet(dataPercentageBilled);

    const workbook = {
      Sheets: {
        'percentage-billed': worksheetPercentageBilled,
      },
      SheetNames: [
        'percentage-billed',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-percentage-billed' + EXCEL_EXTENSION);
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: percentage-billed \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }

}
